/**
 * Project : workspace
 * File    : InventoryDetailsScreen.kt
 * Created : AUTO-GENERATED by scripts/add_kdoc.py
 */

package presentation.screens.business.inventory.details

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.lazy.grid.GridCells
import androidx.compose.foundation.lazy.grid.GridItemSpan
import androidx.compose.foundation.lazy.grid.LazyVerticalGrid
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import com.parmartechnologies.business.feature.business.viewModel.BusinessViewModel
import com.parmartechnologies.commerce.feature.inventory.viewModel.inventory.InventoryViewModel
import com.parmartechnologies.core.feature.inventory.inventory.model.Inventory
import com.parmartechnologies.core.feature.product.model.Product
import com.parmartechnologies.core.navigation.NavigationParam
import component.button.DefaultButton
import component.input.SearchBar
import component.navigation.TopNavBar
import locale.localization
import navigation.AppNavigator
import navigation.common.route.CommonNavRoute
import navigation.route.inventory.InventoryNavRoute
import presentation.screens.business.inventory.stock.component.InventoryCard
import theme.ThemeColor

/**
 * Represents the inventory details screen class.
 */

class InventoryDetailsScreen{
    fun edit(prod:Product,inv: Inventory){
        val newParam = AppNavigator.shared().getNavigationParam()?.update(
            NavigationParam(product = prod, inventory = inv)
        )
        AppNavigator.shared().navigate(InventoryNavRoute.UPDATE,newParam)
    }
    @Composable
    /**
 * Executes the content operation.
 *
 * @receiver TODO
 * @return Unit – no return value.
 */
    fun Content() {
        val businessViewModel = BusinessViewModel()
        val myBusiness = businessViewModel.myBusiness.collectAsState()
        val inventory = AppNavigator.shared().getNavigationParam().inventory
        val product = AppNavigator.shared().getNavigationParam().product
        val viewModel = InventoryViewModel(myBusiness.value)
        val searchQuery = viewModel.searchQuery.collectAsState()
        LaunchedEffect(key1 = Unit) {
            viewModel.clearSearchQuery()
        }
        Column(modifier = Modifier.fillMaxSize().background(ThemeColor.shared().defaultBakground)) {
            TopNavBar(title = "Inventory Details", NavigationParam(), onBackPress = {
                AppNavigator.shared().goBack()
            }, onClickEdit = {
                edit(product!!,inventory!!)
            })
            LazyVerticalGrid(
                columns = GridCells.Adaptive(minSize = 400.dp),
                modifier = Modifier.fillMaxSize().padding(bottom = 60.dp)
            ) {
                item(span = { GridItemSpan(maxCurrentLineSpan) }) {
                    val card = InventoryCard()
                    card.onClick = { inv ->
                        AppNavigator.shared().goBack()
                    }
                    card.inventory = inventory
                    card.content()
                }
                item(span = { GridItemSpan(maxCurrentLineSpan) }) {
                    SearchBar(
                        viewModel,
                        searchQuery.value,
                        localization().inventory.inventorySearchPlaceholder
                    )
                }
//                items() {
//
//                }
                item {
                    DefaultButton("Scan Barcodes",{
                        val newParam = AppNavigator.shared().getNavigationParam().update(
                            NavigationParam(product = product, inventory = inventory)
                        )
                        AppNavigator.shared().navigate(CommonNavRoute.SCANNER,newParam)
                    })
                }
            }
        }
    }
}